import { Component, OnInit } from '@angular/core';
import { Observable, finalize, of } from 'rxjs';
import { EditPlatformSection } from '../../platform-section/platform-section.interface';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { PlatformFaqService } from '../platform-faq.service';
import { PlatformSectionService } from '../../platform-section/platform-section.service';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { FAQAddPayload, FAQForm } from '../platform-faq.interface';

import { helper } from 'src/environments/helper';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { initializeEditor } from 'src/app/utils/angular-editor/editorConfig';

@Component({
  selector: 'app-add-platform-faq',
  templateUrl: './add-platform-faq.component.html',
  styleUrls: ['./add-platform-faq.component.scss'],
})
export class AddPlatformFaqComponent implements OnInit {
  // general error
  errorTitle: string = helper.dialogConfig.headers.errorAtentie;
  errorIcon: string = helper.dialogConfig.icons.error;
  errorType: string = helper.dialogConfig.icons.error;
  helper = helper;

  editorConfig!: AngularEditorConfig;

  token!: string;
  isLoading = false;
  isSectionsLoading = true;
  sections$!: Observable<EditPlatformSection[]>;

  form: FormGroup = new FormGroup({
    name: new FormControl('', [Validators.required]),
    section_id: new FormControl('', [Validators.required]),
    observations: new FormControl('', [Validators.required]),
  });

  constructor(
    private dialogRef: MatDialogRef<AddPlatformFaqComponent>,
    private platformFaqService: PlatformFaqService,
    private platformSectionService: PlatformSectionService,
    private notificationService: NotificationService,
    private authService: AuthService
  ) {
    this.processToken();
  }

  ngOnInit(): void {
    this.getSectionsList();
    this.editorConfig = initializeEditor();
  }

  getSectionsList() {
    let platformResponse = this.platformSectionService.getPlatformSections();

    platformResponse.subscribe({
      next: (sections: any) => {
        this.sections$ = of(sections as EditPlatformSection[]);
        this.isSectionsLoading = false;
      },
      error: (error) => {
        console.log(error);
        this.isSectionsLoading = false;
      },
    });
  }

  closeDialog() {
    this.dialogRef?.close({
      success: false,
    });
  }

  processToken() {
    const tokenObj = this.authService.returnTokenUser();
    tokenObj.then((token) => {
      this.token = token;
      this.platformFaqService.setToken(token);
    });
  }

  submitForm() {
    this.isLoading = true;

    const { name, section_id, observations } = this.form.value as FAQForm;
    const newFAQ: FAQAddPayload = {
      name,
      section_id,
      observations,
    };

    this.platformFaqService
      .addFAQ(newFAQ)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (res) => {
          this.dialogRef.close({ success: true });
        },
        error: (err) => {
          let msg;
          try {
            // try to catch the message from server
            msg = err.error.errors.message[0];
          } catch (error) {
            // controll output message
            msg = helper.dialogConfig.generalMessages.error;
          }
          this.notificationService.warningSwal(
            this.errorTitle,
            msg,
            this.errorIcon
          );
        },
      });
  }
}
